// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1gUc-","title":"Info_title__YUp4R","links":"Info_links__2MhnL","link":"Info_link__1_sn6","logo":"Info_logo__3ro4G"};